import { STEPS } from '../data/fleet'

export default function HowItWorks() {
  return (
    <section className="section section--dark" id="how">
      <div className="wrap">
        <div className="section__head">
          <span className="eyebrow eyebrow--dark">How it runs</span>
          <h2>Your truck or ours</h2>
          <p>
            Pickup costs nothing and the gate is open around the clock. If you
            would rather not hook up, we deliver.
          </p>
        </div>

        <ol className="steps" style={{ listStyle: 'none', margin: 0, padding: 0 }}>
          {STEPS.map((step) => (
            <li className="step" key={step.n}>
              <div className="step__n">{step.n}</div>
              <h3>{step.title}</h3>
              <p>{step.body}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  )
}
